import { Component } from '@theme/component';

class CollectionPromo extends Component {
  /** @type {IntersectionObserverInit} */
  #intersectionObserverInit = {
    threshold: 0.5,
  };

  /** @type {IntersectionObserver | null} */
  #intersectionObserver = null;

  /** @type {boolean} */
  #intersectionTriggered = false;

  /** @returns {HTMLAnchorElement[]} */
  get links() {
    return Array.from(this.querySelectorAll('a'));
  }

  constructor() {
    super();

    this.#intersectionTriggered = false;

    this.#intersectionObserver = new IntersectionObserver(
      this.#handleIntersection.bind(this),
      this.#intersectionObserverInit
    );
  }

  connectedCallback() {
    super.connectedCallback();
    this.links.forEach((link) => {
      link.addEventListener('click', this.#handleClick.bind(this));
    });
    this.#intersectionObserver?.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#intersectionObserver?.disconnect();
  }

  /** @param {IntersectionObserverEntry[]} entries */
  #handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.#intersectionTriggered) {
        this.#intersectionTriggered = true;
        this.#track('view_promotion');
        this.#intersectionObserver?.disconnect();
      }
    });
  }

  /** @param {Event} event */
  #handleClick(event) {
    event.stopPropagation();
    this.#track('select_promotion');
  }

  /** @returns {object | null} */
  #readTrackingData() {
    const script = this.querySelector('script[type="application/json"][data-promo-tracking]');

    if (!script?.textContent) return null;

    try {
      return JSON.parse(script.textContent);
    } catch {
      return null;
    }
  }

  // Needs better implementation in global datalayer

  /** @param {string} eventName */
  #track(eventName) {
    const ecommerceData = this.#readTrackingData();

    // @ts-ignore
    if (!ecommerceData?.promotion_name) return;

    // @ts-ignore
    window.pushEventAfterConsent(() => {
      // @ts-ignore
      window.pushEvent(eventName, {
        ...ecommerceData,
        // @ts-ignore
        user_data: window.userData ? { user_data: window.userData } : {},
      });
    });
  }
}

if (!customElements.get('collection-promo')) {
  customElements.define('collection-promo', CollectionPromo);
}
